import { z } from 'zod';
import { AppointmentPaymentPolicySchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * Booking settings — `tenants/{tid}/bookingSettings/config`.
 *
 * Today this holds one thing: whether an appointment has to be paid for up
 * front, and what happens to that money if the customer doesn't turn up
 * (SPEC D10). It is a document rather than a field on the tenant because
 * booking policy will grow — lead time, cancellation notice, per-outlet
 * overrides — and each of those is an operator decision, not a constant.
 *
 * Every value here is an operator setting with a safe default. Nothing about
 * what a customer is charged is hardcoded anywhere in the server.
 */
export const BookingSettingsSchema = z.object({
  appointmentPayment: AppointmentPaymentPolicySchema.default({
    mode: 'none',
    depositPercent: 20,
    freeCancelHours: 12,
  }),
});
export type BookingSettings = z.infer<typeof BookingSettingsSchema>;

/** Firestore doc id of the single booking-settings document. */
export const BOOKING_SETTINGS_DOC_ID = 'config';

export function bookingSettingsRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/bookingSettings`,
    schema: BookingSettingsSchema,
    name: `tenants/${tenantId}/bookingSettings`,
  });
}
